export default {
    SELECT_DOCUMENT: "Выберите или создайте документ в графическом представлении"
};
